/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PersonalAssetMetaDataDto,
    PersonalAssetMetaDataDtoFromJSON,
    PersonalAssetMetaDataDtoFromJSONTyped,
    PersonalAssetMetaDataDtoToJSON,
} from './PersonalAssetMetaDataDto';
import {
    PersonalAssetTypeEnum,
    PersonalAssetTypeEnumFromJSON,
    PersonalAssetTypeEnumFromJSONTyped,
    PersonalAssetTypeEnumToJSON,
} from './PersonalAssetTypeEnum';

/**
 * 
 * @export
 * @interface UpdatePersonalAssetDto
 */
export interface UpdatePersonalAssetDto {
    /**
     * 
     * @type {PersonalAssetTypeEnum}
     * @memberof UpdatePersonalAssetDto
     */
    type: PersonalAssetTypeEnum | null;
    /**
     * 
     * @type {PersonalAssetMetaDataDto}
     * @memberof UpdatePersonalAssetDto
     */
    metaData?: PersonalAssetMetaDataDto;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonalAssetDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonalAssetDto
     */
    iconName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonalAssetDto
     */
    colorName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonalAssetDto
     */
    currencyCode: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonalAssetDto
     */
    portfolioId: string;
}

export function UpdatePersonalAssetDtoFromJSON(json: any): UpdatePersonalAssetDto {
    return UpdatePersonalAssetDtoFromJSONTyped(json, false);
}

export function UpdatePersonalAssetDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePersonalAssetDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': PersonalAssetTypeEnumFromJSON(json['type']),
        'metaData': !exists(json, 'metaData') ? undefined : PersonalAssetMetaDataDtoFromJSON(json['metaData']),
        'name': json['name'],
        'iconName': json['iconName'],
        'colorName': json['colorName'],
        'currencyCode': json['currencyCode'],
        'portfolioId': json['portfolioId'],
    };
}

export function UpdatePersonalAssetDtoToJSON(value?: UpdatePersonalAssetDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': PersonalAssetTypeEnumToJSON(value.type),
        'metaData': PersonalAssetMetaDataDtoToJSON(value.metaData),
        'name': value.name,
        'iconName': value.iconName,
        'colorName': value.colorName,
        'currencyCode': value.currencyCode,
        'portfolioId': value.portfolioId,
    };
}

